/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
import {BOOKMARKS_COMMUNICATIONS} from '../config';
window.Vue = require('vue');
window.Vuex = require('vuex');
window.vueEventHub = new Vue();
Vue.config.devtools = true;
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.Vue.component(
	'entity_types',
	require('../components/pages/EntityTypesCompiler.vue')
);
window.Vue.component(
	'date_time_sequencer',
	require('../components/forms/DateTimeSequencer.vue')
);
window.Vue.component(
	'location',
	require('../components/forms/GeoLocation.vue')
);
window.Vue.component(
	'name_to_slug',
	require('../components/forms/NameToSlug.vue')
);
window.Vue.component(
	'icon_chooser',
	require('../components/forms/IconChooser.vue')
);
window.Vue.component(
	'image-uploader',
	require('../components/forms/image/ImageUploader.vue')
);
window.Vue.component(
	'image-data-component',
	require('../components/forms/image/ImageDataComponent.vue')
);
window.Vue.component(
	'TableEditor',
	require('../components/forms/table/TableEditor')
);
window.Vue.component(
	'TableCell',
	require('../components/forms/table/TableCell')
);
window.Vue.component(
	'modal',
	require('../../../../app/Shared/Resources/Assets/js/components/notifications/modal.vue')
);
window.Vue.component(
	'table-search',
	require('../components/tables/tableSearch.vue')
);
window.Vue.component(
	'passport-clients',
	require('../components/passport/Clients.vue')
);
window.Vue.component(
	'passport-authorized-clients',
	require('../components/passport/AuthorizedClients.vue')
);
window.Vue.component(
	'passport-personal-access-tokens',
	require('../components/passport/PersonalAccessTokens.vue')
);
window.Vue.component(
	'step-simple-instructions',
	require('../components/steps/step-simple-instructions.vue')
);
window.Vue.component(
	'event-tickets',
	require('../components/pages/ticketing/EventTickets.vue')
);
window.Vue.component(
	'event-ticket-props',
	require('../components/pages/ticketing/EventTicketProps.vue')
);
window.Vue.component(
	'material_select',
	require('../components/forms/select/MaterialSelect.vue')
);
window.Vue.component(
	'log-display',
	require('../components/pages/logs/LogSystemDisplay.vue')
);
window.Vue.component(
	'tags',
	require('../components/forms/Tags.vue')
);
window.Vue.component(
	'pop_over',
	require('../../../../app/Shared/Resources/Assets/js/components/PopOver.vue')
);
window.Vue.component(
    'bookmarks_navigation',
    require('../components/navigation/bookmarksNavigation')
);
window.Vue.component(
    'add_to_bookmark',
    require('../components/navigation/addToBookmark')
);
window.Vue.component(
	'navigation',
	require('../components/navigation/sideNavigation.vue')
);
window.Vue.component(
	'bar-list-checkin-module',
	require('../components/modules/BarListCheckinModule.vue')
);
window.Vue.component(
	'table-vue',
	require('../components/tables/table.vue')
);
window.Vue.component(
	'ticket-groups',
	require('../components/pages/ticketing/TicketGroups')
);
window.Vue.component(
	'coupon-crud',
	require('../components/pages/coupons/CouponCRUD')
);
window.Vue.component(
	'wastage-page',
	require('../components/pages/wastage/WastagePage')
);
window.Vue.component(
	'theme-manager',
	require('../components/theme_manager/ThemeManager')
);
window.Vue.component(
	'graph-list-module',
	require('../components/modules/GraphListModule')
);
window.Vue.component(
	'client-dashboard',
	require('../components/pages/dashboards/ClientDashboard')
);
window.Vue.component(
	'plates',
	require('../../../../app/Shared/Resources/Assets/js/components/Plates')
);
window.Vue.component(
	'vip-tickets-admin-list-edit',
	require('../components/pages/ticketing/VipTicketsAdminListEdit')
);
window.Vue.component(
	'search-bar',
	require('../../../../app/Shared/Resources/Assets/js/components/SearchBar')
);
window.Vue.component(
	'search-user-role-crud',
	require('../components/forms/search/SearchUserRoleCrud')
);
window.Vue.component(
	'search-user',
	require('../components/forms/search/SearchUser')
);
window.Vue.component(
	'entity-managers',
	require('../components/pages/entities/EntityManagers')
);
window.Vue.component(
	'merge-users',
	require('../components/pages/users/MergeUsers')
);
window.Vue.component(
	'pages-manager',
	require('../components/modules/PagesManager')
);


/***************************** base components *********************************/
window.Vue.component(
	'BaseIcon',
	require('../components/base/BaseIcon')
);
window.Vue.component(
	'basecurrencyinput',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseCurrencyInput')
);
window.Vue.component(
	'BaseLoadingAnimation',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseLoadingAnimation')
);
window.Vue.component(
	'bold-words',
	require('../../../../app/Shared/Resources/Assets/js/components/BoldWords')
);


window.Vue.component(
	'BaseInputWithIcon',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseInputWithIcon')
);

window.Vue.component(
	'BaseIconButton',
	require('../components/base/BaseIconButton')
);
window.Vue.component(
	'BaseBackgroundOverlay',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseBackgroundOverlay')
);
window.Vue.component(
	'BaseButton',
	require('../../../../app/Shared/Resources/Assets/js/components/base/buttons/BaseButton')
);
window.Vue.component(
	'BaseButtonRound',
	require('../../../../app/Shared/Resources/Assets/js/components/base/buttons/BaseButtonRound')
);
window.Vue.component(
	'BaseDatePicker',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseDatePicker')
);
window.Vue.component(
    'BaseJsonView',
    require('../../../../app/Shared/Resources/Assets/js/components/base/BaseJsonView')
);
window.Vue.component(
    'BaseBadge',
    require('../components/base/BaseBadge')
);
window.Vue.component(
	'BaseTab',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseTabIn'));
window.Vue.component(
	'BaseSwitch',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseSwitch'));
window.Vue.component(
	'baseSwitch',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseSwitch'));
window.Vue.component(
	'BaseSwitchEvents',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseSwitchEvents'));
window.Vue.component(
	'BaseCodeInput',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseCodeInput'));


let wrappers = [
	'coupon-crud',
	'bar-list-checkin-module',
	'search-bar',
	'client-dashboard',
	'bookmarks_navigation',
	'add_to_bookmark'
];
// Vue.prototype.$bus = new Vue({});
// new Vue({
//     el: '#app',
//     template: '<App/>',
//     components: { App }
// })
window.GLOBAL_VUEJS = {};


for (let i = 0; i < wrappers.length; i++) {
    let wrapper, wrapperCompiled, element, elementList;
    wrapper = `${wrappers[i]}--wrapper`;
    wrapperCompiled = wrapper;
    elementList = document.querySelectorAll(`.${wrapperCompiled}, #${wrapperCompiled}`);
	// console.log('elementList',elementList);
    for (let j = 0; j < elementList.length; j++) {
        let elementListElement = elementList[j];
        if (typeof(elementListElement) != 'undefined' && elementListElement != null) {
        	// does it have an id
            let elementId = elementListElement.id;

            if (typeof( elementListElement.id== 'undefined' || elementListElement.id == null)) {
                elementListElement['id'] = wrapperCompiled;
            }
            elementId = elementListElement.id;
            if(wrapper == 'bookmarks_navigation'){
                GLOBAL_VUEJS[elementId] = new Vue({
                    el: '#' + elementId
                });
			}else{
                GLOBAL_VUEJS[elementId] = new Vue({
                    el: '#' + elementId
                });
			}
            // console.log('elementListElement',elementListElement,'elementId',elementId);

        }
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/config/vueComponents.js